import type React from "react"
import { Box, Container, Typography, Grid, Link, List, ListItem, ListItemIcon, ListItemText, useMediaQuery, useTheme } from "@mui/material"
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline"

const AppDownloadSection: React.FC = () => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down("md"))
  return (
    <Box sx={{ py: { xs: 8, md: 12 }, bgcolor: "background.paper" }}>
      <Container maxWidth="lg">
        <Grid container spacing={4} alignItems="center">
          <Grid item xs={12} md={6}>
            <Typography variant="h2" component="h2" gutterBottom>
              Download Our Android App
            </Typography>
            <Typography variant="h6" color="text.secondary" sx={{ mb: 4 }}>
              Get the convenience of finding cooks and maids on the go. Post your requirements and connect with service
              providers directly from your phone.
            </Typography>

            <Link
              href="https://play.google.com/store/apps/details?id=in.cooksandmaids"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Box
                component="img"
                src={require("../../assets/google-play.png")}
                alt="Get it on Google Play"
                sx={{
                  height: "auto",
                  width: 180,
                  mb: 3,
                }}
              />
            </Link>

            <List>
              {[
                "Post requirements on the go",
                "Get instant notifications when providers respond",
                "Chat directly with verified service providers",
              ].map((text, index) => (
                <ListItem key={index} disablePadding sx={{ mb: 1 }}>
                  <ListItemIcon sx={{ minWidth: 36 }}>
                    <CheckCircleOutlineIcon color="primary" />
                  </ListItemIcon>
                  <ListItemText primary={text} />
                </ListItem>
              ))}
            </List>
          </Grid>

          <Grid item xs={12} md={6} sx={{ display: "flex", justifyContent:  isMobile ? "center" : "flex-end" }}>
            <Box
              sx={{
                width: { xs: 280, md: 320 },
                height: { xs: 560, md: 640 },
                position: "relative",
              }}
            >
              <Box
                sx={{
                  position: "absolute",
                  width: "100%",
                  height: "100%",
                  borderRadius: "40px",
                  overflow: "hidden",
                  border: "8px solid black",
                  bgcolor: "black",
                }}
              >
                <Box
                  component="img"
                  src={require("../../assets/home-screen.jpg")}
                  alt="Cooks and Maids app screenshot"
                  sx={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    borderRadius: "32px",
                  }}
                />
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  )
}

export default AppDownloadSection
